import { render } from "./SqlServerConfigurationForm.vue?vue&type=template&id=2015d640&ts=true"
import script from "./SqlServerConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./SqlServerConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__